<template>
  <div class="wrapper">
    <div class="header">
      <span>{{ $t("dashboard.total_personnel") }}</span>
    </div>
    <div class="employee-wrapper">
      <div class="total-employee">
        <div>{{ totalEmployeees }}</div>
      </div>
      <div class="text">
        <span>{{ $t("dashboard.personnel") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TotalEmployees",
  // props: ["totalemployee"],
  data() {
    return {};
  },

  async created() {
    await this.$store.dispatch("dashboard/getEmployeees");
  },

  computed: {
    ...mapGetters({
      totalEmployeees: "dashboard/totalEmployees",
    }),
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  background: #ffffff;
  border: 1px solid #efefef;
  border-radius: 10px;
  padding: 30px 20px;
  height: 420px;
  // min-height: 280px; 
  // max-height: 500px;
  .employee-wrapper {
    place-content: center;
    display: flex;
    height: 70%;
    flex-direction: column;
  }

  .header {
    font-family: "-apple-system,BlinkMacSystemFont," Segoe UI ",Roboto,"
      Helvetica Neue ",Arial," Noto Sans ",sans-serif," Apple Color Emoji ","
      Segoe UI Emoji "," Segoe UI Symbol "," Noto Color Emoji "";
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 35px;
    color: #303c54;
  }
  .total-employee {
    display: grid;
    color: #3488eb;
    font-family: "-apple-system,BlinkMacSystemFont," Segoe UI ",Roboto,"
      Helvetica Neue ",Arial," Noto Sans ",sans-serif," Apple Color Emoji ","
      Segoe UI Emoji "," Segoe UI Symbol "," Noto Color Emoji "";
    font-weight: 700;
    font-size: 100px;
    line-height: 100%;
    text-align: center;
  }
  .text {
    margin-top: 7px;
    text-align: center;
    color: #978e8e;
    font-size: 18px;
  }
}
</style>